
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";

import thai from "../../assets/thai.png"
import magyar from "../../assets/magyar.png"
import arrow from "../../assets/arrow.png"

function MagyarThai({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Magyar thai fordító</title>
                <meta name='description' content="Ingyenes magyar thai fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Magyar thai fordító" />
                <link rel="canonical" href="https://online-fordito.hu/magyar-thai-fordito" />
            </Helmet>
            <h1>Magyar thai fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>


                <div className="sectionhead">
                    <h2>A magyar és thai nyelv </h2>
                    <img src={magyar} alt="magyar zászló"></img>
                    <img src={thai} alt="thai zászló"></img>
                </div>


                <p>Íme néhány alapvető különbség a thai és a magyar nyelv között:</p>

                <h3>Hangrendszer</h3>

                <p>A thai nyelvben több mint 40 hang található, köztük magas, mély, sima és szöveges hangok. A magyar nyelvben kevesebb hang van, mint a thaiban, és más hangok is vannak jelen.</p>
               
                <h3>Írásrendszer</h3>

                <p>A thai nyelv thai ábécét (Thai szkript) használ, amely egy összetett írásrendszer, amelyben minden hanghoz egy betű és/vagy egy diakritikus jel tartozik. A magyar nyelvben latin betűkkel írnak.</p>
                
                <h3>Nyelvtani szerkezet</h3>

                <p>A thai nyelv egy tonális nyelv, ami azt jelenti, hogy a hangmagasság jelentésváltozásokat hordoz. A magyar nyelv nem tonális.
                A thai nyelvben a szavak többnyire egyszótagúak, míg a magyar nyelvben a szavak hosszabbak lehetnek, és a szótagstruktúrában is eltérnek.</p>
                
                
                <h3>Szórend</h3>

                <p>A thai nyelvben az alany-ige-állítmány (SVO) szórend a leggyakoribb, de a szórend változhat kontextustól függően. A magyar nyelvben a szórend általában SVO, de itt is lehetnek változások.</p>
               
                <h3>Szókincs</h3>

                <p>A thai és a magyar nyelv szókincse is teljesen eltérő. A thai nyelv tónusok és partikulák használatával fejezi ki a jelentést, míg a magyar nyelvben a szavak és a mondat szerkezete játszik fontos szerepet.</p>

                <div className="sectionbottom">
                    <Link to="/thai-magyar-fordito">Thai magyar fordító</Link>
                    <img src={thai} alt="thai zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>
                </div>
            </section>
        </>

    )
}

export default MagyarThai;